import React from "react";
import { inject, observer } from "mobx-react";
import "./DateRangePicker.scss";
import { computed } from "mobx";

import _ from "lodash";
import dayjs, { Dayjs } from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);
@inject("controller")
@observer
export class CalendarCell extends React.Component<{
  controller?: any;
  date: any;
  availableRange?: { from: Dayjs; to: Dayjs };
  availableDates?: Array<Dayjs>;
  singleSelect?: boolean;
  availableSelectedRange?: number;
  disabled?: boolean;
}> {
  @computed get cellClass() {
    const { date } = this.props;
    const { calendarsDate, selectedDates, rangeFrom } = this.props.controller;

    const classes = [];

    // If the day is from another month, show it in grey text
    if (date.isBefore(calendarsDate, "month") || date.isAfter(calendarsDate, "month")) {
      classes.push("otherMonthDay");
    }

    // If the range starts or ends from this day, select it
    if (
      (selectedDates.length > 0 && date.isSame(selectedDates[0], "day")) ||
      (selectedDates.length > 1 && date.isSame(selectedDates[1], "day"))
    ) {
      classes.push("selected");
    }

    // If first day selected for the range, highlight the days until the user select 2nd day
    if (
      selectedDates.length === 1 &&
      (date.isBetween(selectedDates[0], rangeFrom) || date.isBetween(rangeFrom, selectedDates[0]))
    ) {
      classes.push("hover");
    }

    // Highlight the days in between the range
    if (selectedDates.length === 2 && date.isBetween(selectedDates[0], selectedDates[1])) {
      classes.push("between");
    }

    // Show todays day
    if (date.isSame(dayjs(), "day")) {
      classes.push("today");
    }

    if (this.getDisabledDate(date)) {
      classes.push("disabled");
    }

    return "calendarDayCell " + classes.join(" ");
  }

  private getDisabledDate = (date) => {
    const { controller, availableSelectedRange, availableRange, disabled } = this.props;
    const { selectedDates } = controller;

    if (disabled) {
      return true;
    }

    if (availableRange) {
      if (date.isBefore(availableRange.from)) {
        return true;
      }
      if (date.isAfter(availableRange.to)) {
        return true;
      }
    }

    if (this.props.singleSelect && this.props.availableDates) {
      return !this.props.availableDates.some((d) => date.isSame(d, "day"));
    }

    if (availableSelectedRange && selectedDates.length === 1) {
      const rangeAfterSelected = dayjs(selectedDates[0], "YYYY-MM-DD").add(availableSelectedRange, "d");
      const rangeBeforeSelected = dayjs(selectedDates[0], "YYYY-MM-DD").subtract(availableSelectedRange, "d");

      if (!date.isBetween(rangeBeforeSelected, rangeAfterSelected)) {
        return true;
      }
    }

    return false;
  };

  private renderMouseOver = (date) => {
    if (this.getDisabledDate(date) || this.props.controller.props.singleSelect) {
      return;
    }

    this.props.controller.rangeFrom = date;
  };

  private renderCell = () => {
    const { date } = this.props;

    return (
      <div
        className={this.cellClass}
        onClick={(e) => (this.getDisabledDate(date) ? e.preventDefault() : this.props.controller.handleSelection(date))}
        onMouseEnter={() => this.renderMouseOver(date)}
      >
        {date.date()}
      </div>
    );
  };

  public render() {
    return this.renderCell();
  }
}
